export enum StatusWezwania {
  Nowe = 1,
  Zatwierdzono,
  Wyslano,
  Doreczono,
  Zweryfikowano,
  PrzekazanoDoPodpisu,
}
